var _path, _path2, _path3, _path4, _path5, _path6, _path7;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPolkadot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23ZM12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "#F0F3F8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 7.4598C13.5696 7.4598 14.8421 6.72492 14.8421 5.8184C14.8421 4.91188 13.5696 4.177 12 4.177C10.4303 4.177 9.15777 4.91188 9.15777 5.8184C9.15777 6.72492 10.4303 7.4598 12 7.4598Z",
    fill: "#E6007A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 19.823C13.5696 19.823 14.8421 19.0881 14.8421 18.1816C14.8421 17.275 13.5696 16.5402 12 16.5402C10.4303 16.5402 9.15777 17.275 9.15777 18.1816C9.15777 19.0881 10.4303 19.823 12 19.823Z",
    fill: "#E6007A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.03854 9.72995C8.82339 8.38072 8.81842 6.9195 8.02744 6.46624C7.23646 6.01298 5.959 6.73931 5.17415 8.08855C4.3893 9.43779 4.39427 10.899 5.18525 11.3523C5.97623 11.8055 7.25369 11.0792 8.03854 9.72995Z",
    fill: "#E6007A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8258 15.9115C19.6107 14.5623 19.6057 13.1011 18.8147 12.6478C18.0237 12.1945 16.7463 12.9209 15.9614 14.2701C15.1766 15.6194 15.1816 17.0806 15.9725 17.5338C16.7635 17.9871 18.041 17.2608 18.8258 15.9115Z",
    fill: "#E6007A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.02743 17.5337C8.81841 17.0805 8.82338 15.6193 8.03854 14.27C7.25369 12.9208 5.97623 12.1945 5.18525 12.6477C4.39427 13.101 4.3893 14.5622 5.17414 15.9114C5.95899 17.2607 7.23645 17.987 8.02743 17.5337Z",
    fill: "#E6007A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8147 11.3523C19.6056 10.8991 19.6106 9.43784 18.8258 8.0886C18.0409 6.73936 16.7635 6.01303 15.9725 6.46629C15.1815 6.91955 15.1765 8.38077 15.9614 9.73C16.7462 11.0792 18.0237 11.8056 18.8147 11.3523Z",
    fill: "#E6007A"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolkadot);
export default __webpack_public_path__ + "static/media/polkadot.71f01e96e955317f461df08b2ef29ab3.svg";
export { ForwardRef as ReactComponent };